import { ReactNode, useEffect, useState } from "react";

import { useAppDispatch } from "app/hooks";
import { LoadingSpinner } from "react/components/LoadingSpinner";
import { Client } from "@genesys/cloud-frontend/dist/mjs/client";
import config from "config";

export function RequireNoAuth({ children }: { children: ReactNode }) {
    const dispatch = useAppDispatch();
    const [clientInitialized, setClientInitialized] = useState(false);
    useEffect(() => {
        const initialize = async () => {
            try {
                await Client.getClient(config.appName, { authToken: null });
            } catch (error) {
                console.log(error);
            } finally {
                setClientInitialized(true);
            }
        };
        initialize();
    }, [dispatch]);

    return <>{clientInitialized ? children : <LoadingSpinner />}</>;
}
